<template>
    <div class="container-fluid">
        <h1
            class="page-title"
            v-if="!product.id"
        >
            New Service Product
        </h1>
        <h1
            class="page-title"
            v-if="product.id"
        >
            Edit Service Product
        </h1>
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="save()"
                >
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label for="name">Product Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Product Name"
                                    v-model="product.name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group">
                                <label for="name">E.S. Years</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="1"
                                    id="es_years"
                                    placeholder="0"
                                    v-model="product.es_years"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.es_years }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.es_years"
                                >{{ errors.es_years[0] }}</small>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label for="name">Fitting Price</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">£</span>
                                </div>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    class="form-control"
                                    placeholder="0.00"
                                    v-model="product.fitting_price"
                                >
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label for="name">ID Sign Price</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">£</span>
                                </div>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    class="form-control"
                                    placeholder="0.00"
                                    v-model="product.id_sign_price"
                                >
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group form-group-checkbox">
                                <label for="inventory">Show in inventory:</label>
                                <input
                                    type="checkbox"
                                    v-model="product.show_inventory"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Variation Name</th>
                                        <th>Basic Service</th>
                                        <th>Refill/Recharge</th>
                                        <th>Extended Service</th>
                                        <th>Recon</th>
                                        <th>New Price</th>
                                        <th><!-- options --></th>
                                    </tr>
                                </thead>
                                <tbody v-if="product.variations">
                                    <tr
                                        v-for="(variation, index) in product.variations"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="variation.name"
                                                placeholder="Variation"
                                            >
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control"
                                                    placeholder="0.00"
                                                    v-model="variation.bs_price"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control"
                                                    placeholder="0.00"
                                                    v-model="variation.rc_price"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control"
                                                    placeholder="0.00"
                                                    v-model="variation.es_price"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control"
                                                    placeholder="0.00"
                                                    v-model="variation.rcon_price"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control"
                                                    placeholder="0.00"
                                                    v-model="variation.new_price"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <button
                                                type="button"
                                                class="btn btn-small btn-outline-danger"
                                                @click="removeVariation(index)"
                                                :disabled="!canRemoveVariations"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td
                                            class="text-right"
                                            colspan="6"
                                        >
                                            <button
                                                class="btn btn-primary"
                                                type="button"
                                                @click="addVariation"
                                            >
                                                <i class="fa fa-plus" /> Add Variation
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button
                                type="submit"
                                class="btn btn-primary"
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                v-if="product.id"
                                @click="deleteProduct"
                                class="btn btn-outline-danger"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>
                            <button
                                type="button"
                                @click="$router.go(-1)"
                                class="btn btn-outline-secondary"
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Service from '../../../services/ServiceProductsService';

export default {
    props: ["id"],
    data: function () {
        return {
            product: {
                variations: [
                    {
                        name: 'Standard',

                    }
                ],
            },
            errors: {},
        }
    },
    computed: {
        canRemoveVariations: function () {
            return this.product.variations.length > 1;
        }
    },
    mounted: function () {
        if (this.id) {
            Service.get(this.id).then(
                res => {
                    this.product = res.data;
                    if (!this.product.variations) {
                        this.product.variations = [
                            {
                                name: 'Standard',

                            }
                        ];
                    }
                },
                err => {
                    alert("Error: Could not load product");
                }
            );
        }
    },
    methods: {
        removeVariation: function (index) {
            this.product.variations.splice(index, 1);
            this.$forceUpdate();
        },
        addVariation: function () {
            this.product.variations.push({});
            this.$forceUpdate();
        },
        save: function () {
            this.errors = {};
            if (this.product.id) {
                Service.update(this.product).then(
                    res => {
                        this.product = res.data;
                        alert("Service product saved");
                    },
                    err => {
                        this.errors = err.response.data.errors;
                    }
                );
            } else {
                Service.create(this.product).then(
                    res => {
                        this.product = res.data;
                        alert("Service product saved");
                        this.$router.push({
                            name: "office.service_product.edit",
                            params: {id: this.product.id}
                        });
                    },
                    err => {
                        this.errors = err.response.data.errors;
                    }
                );
            }
        },
        deleteProduct: function () {
            var confirm = window.confirm('Are you sure you want to delete this product?');

            if (confirm) {
                Service.delete(this.product).then(() => {
                    alert('Service product deleted successfully');
                    this.$router.push({name: "office.service_products.search"});
                });
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-products/EditComponent.vue